import { getSpecialties } from '@services/queries/specialtyQueries';
import { serviceService } from '@services/services/serviceService';

import { store } from '@store';
import { entryTypeSpecialtyService } from '@store/EntryTypeSpeciality/entryTypeSpecialtyService';
import { entryTypeService } from '@template/services/entryType/entryTypeService';

import { SpecialtyListItemData } from 'chaika-frontend-types/frontend-cms';
import compact from 'lodash/compact';
import flatMap from 'lodash/flatMap';
import uniq from 'lodash/uniq';

export enum RelationType {
    Services = 'Services',
}

class SpecialtyRelationsService {
    public async loadEntryTypeSpecialties(): Promise<void> {
        const specialtyIds: string[] = [];

        const specialties = getSpecialties();
        specialties.forEach(({ id }) => {
            if (store.entryTypeSpecialityList.getBySpecialtyId(id).length === 0 && !specialtyIds.includes(id)) {
                specialtyIds.push(id);
            }
        });

        if (specialtyIds.length > 0) {
            await entryTypeSpecialtyService.find({ specialtyIds });

            const entryTypeIds = store.entryTypeSpecialityList.getByEntryTypeIds();

            if (entryTypeIds.length > 0) {
                await entryTypeService.loadByIds(entryTypeIds);
            }
        }
    }

    public async loadServices(specialties: SpecialtyListItemData[]): Promise<void> {
        const serviceIds = uniq(
            compact(
                flatMap(specialties, ({ defaultServiceId, defaultOnlineServiceId }) => [
                    defaultServiceId,
                    defaultOnlineServiceId,
                ]),
            ),
        );

        if (serviceIds.length > 0) {
            serviceService.loadByIds(serviceIds);
        }
    }
}

export const specialtyRelationsService = new SpecialtyRelationsService();
